import axios, { AxiosResponse } from "axios";
import AxiosService from "./Axios";
import Api from "./Api";
import SessionService from "../services/session/SessionService";

class AiApi {
    
    public async chat(conversationId: string, message: string): Promise<AxiosResponse<any>> {
        return AxiosService.post('/ai/chat/' + conversationId, { message });
    }

    public async chatStream(conversationId: string, message: string, 
        onMessage: (content: string) => void, 
        onComplete?: () => void,
        onError?: (error: any) => void
    ): Promise<void> {
        let authorization = SessionService.getInstance().getAuthoriazation();
        
        try {
            const response = await fetch(`${Api.URL_PREFIX}/ai/chat/${conversationId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authorization || ''
                },
                body: JSON.stringify({ message })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const reader = response.body?.getReader();
            if (!reader) {
                throw new Error('No response body');
            }

            const decoder = new TextDecoder('utf-8');
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    break;
                }

                let thisDecoded = decoder.decode(value, { stream: true });
                buffer += thisDecoded;
                onMessage(thisDecoded);
            }
            if (onComplete) {
                onComplete();
            }

        } catch (error) {
            if (onError) {
                onError(error);
            }
            throw error;
        }
    }
}

export default AiApi;